import React from 'react';
import PropTypes from 'prop-types';
import { MostPopularGames as MostPopularGamesCore } from 'core/components';
import { withCoreComponent, withUser } from 'core/hocs';

import { LoggedIn } from './logged-in/logged-in';
// import { NotLoggedIn } from './not-logged-in/not-logged-in';

export const MostPopularGamesUI = ({
  isUserLoggedIn,
  games,
  isInProgress,
  className
}) => {
  const MostPopularGamesComponent = LoggedIn;

  return (
    <div className={className}>
      <MostPopularGamesComponent
        isUserLoggedIn={isUserLoggedIn}
        games={games}
        isInProgress={isInProgress}
      />
    </div>
  );
};

MostPopularGamesUI.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  isInProgress: PropTypes.bool.isRequired,
  games: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
};

MostPopularGamesUI.defaultProps = {
  games: [],
  className: null,
};

export const MostPopularGames = withCoreComponent(MostPopularGamesCore, withUser(MostPopularGamesUI));
